import 'core-js/stable'
import './config/interceptor'
import './config/vee-validate'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { VueMaskDirective } from 'v-mask'
import babelPolyfill from 'babel-polyfill'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.directive('mask', VueMaskDirective)
Vue.prototype.$log = console.log.bind(console)

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
